/* eslint-disable no-shadow */
import toastService from "Root/profile/toastService/index";
import { isJson as testForJson } from "Helpers/util";
function getCookie(name) {
    const cookies = document.cookie.split(";");
    let cookieValue = "";
    let cookieKey = "";
    cookies.forEach((cookie) => {
        const splitCookie = cookie.split("=");
        const cookieName = splitCookie[0].trim();
        if (cookieName === name) {
            [cookieKey, cookieValue] = splitCookie;
        }
    });
    return cookieValue;
}
const parseJsonOrString = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
};
var HTTPMethods;
(function (HTTPMethods) {
    HTTPMethods["GET"] = "GET";
    HTTPMethods["POST"] = "POST";
    HTTPMethods["PUT"] = "PUT";
    HTTPMethods["DELETE"] = "DELETE";
})(HTTPMethods || (HTTPMethods = {}));
function apiService(url, method, body, hideError = false) {
    const baseUrl = `${process.env.NEXT_PUBLIC_DJANGO_SERVER_URL || ""}`;
    const requestParams = {
        method,
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": `${getCookie("csrftoken")}`,
        },
    };
    if (method === HTTPMethods.POST || method === HTTPMethods.PUT) {
        requestParams.body = JSON.stringify(body);
    }
    return fetch(baseUrl + url, {
        ...requestParams,
    })
        .then((response) => {
        if (!response.ok) {
            return response.json().then((body) => {
                if (body.length === 0) {
                    throw new Error(response.statusText);
                }
                else {
                    throw new Error(JSON.stringify(body));
                }
            });
        }
        return response.text().then((data) => (data.length === 0 ? null : parseJsonOrString(data)));
    })
        .then((data) => data)
        .catch((error) => {
        if (!hideError) {
            // if 500, return generic response
            if (error.status >= 500) {
                toastService.errorMessage("Something went wrong.");
            }
            // check if it's our new error shape
            // (e.g. message, error_code)
            if (error.error_code && error.message) {
                toastService.errorMessage(error.message);
            }
            // legacy code for backwards compatibility
            if (error.response && error.response.data) {
                const errorMessage = error.response.data;
                toastService.errorMessage(errorMessage);
                throw error;
            }
            else if (error) {
                if (error.message && testForJson(error.message)) {
                    if ("message" in JSON.parse(error.message)) {
                        if (JSON.parse(error.message).message !== "") {
                            toastService.errorMessage(JSON.parse(error.message).message);
                        }
                    }
                }
                else {
                    toastService.errorMessage(error.message);
                }
            }
            else {
                toastService.errorMessage("Something went wrong.");
            }
        }
        throw error;
    });
}
const httpService = {
    get: (url, hideError) => apiService(url, HTTPMethods.GET, null, hideError),
    post: (url, body, hideError) => apiService(url, HTTPMethods.POST, body, hideError),
};
export default httpService;
